function Show<T>({
    when,
    children,
}: {
    when: T | undefined | null | boolean
    children: TChildren
}) {
    if (when) {
        return <>{children}</>
    }

    return null
}

export default Show
